// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1GPuq","checkboxCol":"Table_checkboxCol__lbFJk","emailCol":"Table_emailCol__6PZXS","actionCol":"Table_actionCol__2Uwmm"};